import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../../me'

import { getActionsConfig } from './actions'
import { Api } from './api.service'
import * as effects from './effects'
import { registerMarkdownExtension } from './markdown-extension'
import { Selectors } from './selectors'
import { State } from './state'

@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ApiService} */
  public readonly api = ngCore.inject(Api)

  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'DmsSchema',
      selectors: () => new Selectors(this),
    })
    const meFeature = ngCore.inject(me.Feature)
    // NOTE: Order matters! `loadSchemaOnRequest` must be registered first
    // because `triggerSchemaLoading` dispatches `loadSchema.request`, which
    // `loadSchemaOnRequest` listens for. If `loadSchemaOnRequest` is not
    // registered first, it will miss the dispatched request.
    this.registerEffects(
      effects.loadSchemaOnRequest(),
      effects.triggerSchemaLoading(meFeature),
    )

    registerMarkdownExtension(this)
  }
}
